class TaxCalculator {
	constructor({ monthcardPrice = 0, companyCardPrice = 0, travelKm = 0 }) {
		this._TransportDeductionRate1MinKm = 25;
		this._TransportDeductionRate1MaxKm = 120;
		this._TransportDeductionRate2MinKm = 121;
		this._TransportDeductionRate1 = 2.28;
		this._TransportDeductionRate2 = 1.14;
		this._NumWorkDaysPrYear = 216;
		this._TaxPercentWithoutTop = 37.7;
		this._TaxPercentWithMiddle = 48.9;
		this._TaxPercentWithTop = 55.9;
		this._TaxPercentWithTopTop = 60.5;
		this._EquationDeductionPercentage = 25.1;

		this.monthcardPrice = parseFloat(monthcardPrice);
		this.companyCardPrice = parseFloat(companyCardPrice);
		this.travelKm = parseFloat(travelKm);
	}

	BefFradragAarligSats1() {
		if (this.travelKm * 2 > this._TransportDeductionRate1MinKm - 1) {
			return (
				this._NumWorkDaysPrYear *
				this._TransportDeductionRate1 *
				(Math.min(this._TransportDeductionRate1MaxKm, this.travelKm * 2) -
					this._TransportDeductionRate1MinKm +
					1)
			);
		} else {
			return 0;
		}
	}

	BefFradragAarligSats2() {
		if (this.travelKm * 2 > this._TransportDeductionRate1MaxKm - 1) {
			return (
				this._NumWorkDaysPrYear *
				this._TransportDeductionRate2 *
				(this.travelKm * 2 - this._TransportDeductionRate2MinKm + 1)
			);
		} else {
			return 0;
		}
	}

	BefFradragAarlig() {
		return this.BefFradragAarligSats1() + this.BefFradragAarligSats2();
	}

	KortPrisAar() {
		return 12 * this.monthcardPrice;
	}

	TotalKortPrisVirk() {
		return this.KortPrisAar() * (this.companyCardPrice / (12 * this.monthcardPrice));
	}

	LoanNedgangUdenTop() {
		return this.TotalKortPrisVirk() * (100 - this._TaxPercentWithoutTop) / 100 * -1;
	}

	LoanNedgangMedMellem() {
		return this.TotalKortPrisVirk() * (100 - this._TaxPercentWithMiddle) / 100 * -1;
	}

	LoenNedgangMedTop() {
		return this.TotalKortPrisVirk() * (100 - this._TaxPercentWithTop) / 100 * -1;
	}

	LoanNedgangMedToptop() {
		return this.TotalKortPrisVirk() * (100 - this._TaxPercentWithTopTop) / 100 * -1;
	}

	MistetBefordringsFradrag() {
		return this.BefFradragAarlig() * (this._EquationDeductionPercentage / 100) * -1;
	}

	AarligBesparelseUdenTop() {
		return this.KortPrisAar() + this.LoanNedgangUdenTop() + this.MistetBefordringsFradrag();
	}

	AarligBesparelseMedMellem() {
		return this.KortPrisAar() + this.LoanNedgangMedMellem() + this.MistetBefordringsFradrag();
	}

	AarligBesparelseMedTop() {
		return this.KortPrisAar() + this.LoenNedgangMedTop() + this.MistetBefordringsFradrag();
	}

	AarligBesparelseMedTopTop() {
		return this.KortPrisAar() + this.LoanNedgangMedToptop() + this.MistetBefordringsFradrag();
	}

	Erhvervsrabat() {
		return this.TotalKortPrisVirk() - this.KortPrisAar();
	}

	NedgangBruttoLoen() {
		return this.TotalKortPrisVirk() * -1;
	}

	MaanedliggBesparelseUdenTop() {
		return this.AarligBesparelseUdenTop() / 12;
	}

	MaanedliggBesparelseMedMellme() {
		return this.AarligBesparelseMedMellem() / 12;
	}

	MaanedligBesparelseMedTop() {
		return this.AarligBesparelseMedTop() / 12;
	}

	MaanedligBesparelseMedTopTop() {
		return this.AarligBesparelseMedTopTop() / 12;
	}
}

export default TaxCalculator;
export const Calculate = (inputData) => {
	return new TaxCalculator(inputData);
};
